import commonService from './commonService'
import utils from './utils'

const getAll = async (signal = null) => {
  return await commonService.getAll('mandates', signal)
}

const get = async (id, signal = null) => {
  return await commonService.get('mandates', id, signal)
}

const getCurrent = async (signal = null) => {
  const url = `${utils.url}/mandates/current`
  return await commonService.load(url, signal, null)
}

export default { getAll, get, getCurrent }
